export const getCurrentEditingPromoCodeId = state => state.pages.promoCodePage.currentEditingPromoCodeId



/** WEBPACK FOOTER **
 ** ./src/selectors/promo-code/promo-code-selectors.js
 **/